module.exports = __webpack_public_path__ + "static/media/hati_paile_tarul.66621789.png";